import axios from "axios";
import moment from "moment";
import { getXRFHeaderValue } from "../utils/getXRFHeaderValue";

const xaFormat = "DD-MM-YYYY";

class PageMetricsService {
  getPageMetrics(itemid, pageIdHash, start, end) {
    const startDate = moment(start).format(xaFormat);
    const endDate = moment(end).format(xaFormat);
    console.log(`loading XA data: ${startDate} | ${endDate}`);
    const pageDimensionId = "30E2C2BB63C543D2B6168488C93C971F";
    const serviceUri = `/sitecore/api/ao/aggregates/all/${pageDimensionId}/${pageIdHash}?&dateGrouping=collapsed&&dateFrom=${startDate}&dateTo=${endDate}&keyGrouping=by-key`;
    const options = {
      headers: {
        "content-type": "application/json",
        "X-RequestVerificationToken": getXRFHeaderValue(),
        "X-Requested-With": "XMLHttpRequest"
      },
      withCredentials: true
    };
    return axios
      .get(serviceUri, options)
      .then(res => res.data)
      .catch(error => {});
  }

  // TODO: using dev version for demo/troubleshooting
  getPageVisitHistory(itemId, pageIdHash, start, end) {
    return axios
      .get('/sitecore/shell/client/Applications/altola/insights/data/page-visit-history.json')
      .then(res => res.data)
      .catch(error => { });
  }
}

export default new PageMetricsService();


// WEBPACK FOOTER //
// ./src/data/PageMetricsService.prod.js